import React from "react";
import styled from "styled-components";

import Image from "./Icons/Image";
import { useTheme } from "styled-components";

const Label = styled.div`
  font-size: 16px;
  margin: 0 0 15px;
  color: ${({ theme }) => theme.text.text};
  font-family: "PP Formula";
`;

const Content = styled.div`
  font-size: 12px;
  line-height: 1.5;
  max-width: 275px;
  display: inline-block;
  font-family: "PP Formula";
  color: ${({ theme }) => theme.text.text};
`;

const NoResults = ({ label, content }) => {
  const theme = useTheme();

  return (
    <div style={{ textAlign: "center" }}>
      <Image theme={theme.global.name} />

      {label && <Label>{label}</Label>}

      {content && <Content>{content}</Content>}
    </div>
  );
};

export default NoResults;
